import { openSidebar } from '../ui/sidebar.js';
import { initArtFrameHover } from './art-frame-hover.js';

jQuery(function ($) {

    initArtFrameHover();

    // Cache en memoria JS para latencia 0 ms en segundas pasadas
    let modelCache = {};

    const categoryLabels = [
        window.translations.impact__materials,
        window.translations.impact__packaging,
        window.translations.impact__durability,
        window.translations.impact__production,
        window.translations.impact__waste,
        window.translations.impact__visual,
    ];

    /** Ajax Add To Cart */
    $("body").on("click", "form .single_add_to_cart_button", function (e) {

        e.preventDefault();

        let product_data = {};

        try {
            const raw = document.getElementById("sc-product-data")?.textContent;
            if (raw) {
                product_data = JSON.parse(raw);
            }
        } catch (e) {
            console.warn("❌ Error al parsear product_data JSON:", e);
        }

        let button = $(this),
            form = button.closest("form.cart"),
            product_id = button.val(),
            variation_id = form.find('input[name="variation_id"]').val() || 0,
            quantity = form.find('input[name="quantity"]').val() || 1;

        // Recolectar atributos seleccionados (attribute_pa_color, etc)
        /* let variation = {};
        form.find('select[name^="attribute_"], input[name^="attribute_"]:checked').each(function () {
            let name = $(this).attr("name"),
                value = $(this).val();
            if (value.length > 0) {
                variation[name] = value;
            }
        }); */

        let variation = {};

        let data = {
            action: "woocommerce_ajax_add_to_cart",
            product_id: product_id,
            quantity: quantity,
            variation_id: variation_id,
            variation: variation
        };

        $(document.body).trigger("adding_to_cart", [button, data]);

        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'POST',
            data: data,

            beforeSend: function () {
                button.prop("disabled", true);
                button.find(".btn-label").addClass("hidden");
                button.find('.add-spiner').removeClass("hidden");
            },
            success: function (response) {
                if (response.error && response.product_url) {
                    window.location = response.product_url;
                    return;
                }

                $(document.body).trigger("added_to_cart", [
                    response.fragments,
                    response.cart_hash,
                    button,
                    product_data
                ]);
                // WooCommerce reemplaza los fragments automáticamente
            },
            error: function (xhr, status, error) {
                console.error("❌ Error al añadir al carrito:", error);
            },
            complete: function () {
                button.prop("disabled", false);
                button.find(".btn-label").removeClass("hidden");
                button.find('.add-spiner').addClass("hidden");
            },
        });

        return false;
    });

    /** Abrir modal cesta cuando se añade producto por ajax */ 
    $("body").on("added_to_cart", function () {

        $(".added_to_cart.wc-forward").remove();

        let $sidebar = $("#sidebar-cart");
        openSidebar($sidebar);

        $(".product-form-cta.add-to-cart").css({ background: "", "border-color": "" });
        $(".product-form-cta.add-to-cart").text('epep');
    });

    /** Apex charts (impacto / responsabilidad) */ 
    $(".chart-data").each(function () {
        let chart_values = $(this).data('chart_data');
        const chartId = $(this).data('chart-id') || 'impact-chart';

        if (!chart_values) return;

        chart_values = Object.values(chart_values);

        let options = {
            series: [{ name: 'Sustainability', data: chart_values }],
            plotOptions: { radar: { polygons: { strokeColor: '#E7E5E4' } } },
            stroke: { show: true, width: 2, colors: [], dashArray: 0 },
            fill: { opacity: .25, colors: '#78716C' },
            labels: ['1', '2', '3', '4', '5', '6'],
            tooltip: {
                custom: function ({ series, seriesIndex, dataPointIndex }) {
                    const value = series[seriesIndex][dataPointIndex];
                    const label = categoryLabels[dataPointIndex];
                    return `<div class="custom-tooltip py-1.5 px-3 rounded-md shadow-md"><span class="text-sm font-normal text-vertical-trim">${label}: ${value} / 100</span></div>`;
                }
            },
            markers: { size: 5 },
            chart: { height: 315, type: 'radar', toolbar: { show: false } },
            yaxis: { max: 100, tickAmount: 5 },
            xaxis: {
                labels: {
                    style: { colors: '#78716C', fontSize: '12px', fontFamily: 'SuisseIntl', fontWeight: 400 }
                }
            }
        };

        const el = document.getElementById(chartId);
        if (el) {
            let chart = new ApexCharts(el, options);
            chart.render().then(() => {
                $('.impact-sections li').each(function () {
                    const index = parseInt($(this).data('index'), 10);
                    $(this).on('mouseenter', function () {
                        const $marker = $('.apexcharts-series-markers').eq(index);
                        if ($marker.length) {
                            $marker[0].dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
                        }
                    });
                    $(this).on('mouseleave', function () {
                        const $marker = $('.apexcharts-series-markers').eq(index);
                        if ($marker.length) {
                            $marker[0].dispatchEvent(new MouseEvent('mouseout', { bubbles: true }));
                        }
                    });
                });
            });
        }
    });

    $('.sc-radio-pill').on('click', function(e) {
        var $input = $(this).find('input[type="radio"]');

        if ($input.prop('checked')) {
            $input.prop('checked', false).trigger('change');
        } else {
            $input.prop('checked', true).trigger('change');
        }
    });

    /**
     * Feedback de navegación al cambiar de Modelo.
     * Cada modelo es un producto distinto (enlace real), así que hay unos segundos
     * sin respuesta visual. Marcamos el enlace clicado y atenuamos la galería.
     * El estado lo limpia la propia navegación; el pageshow cubre la vuelta atrás.
     */
    /* const $modelLinks = $('.models a[data-post-id]');

    if ($modelLinks.length) {
        $modelLinks.on('click', function (e) {
            // Respetar abrir en pestaña nueva / descargas / modificadores
            if (e.which > 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

            const $link = $(this);

            // Si ya es el modelo activo no navega a ningún sitio nuevo
            if ($link.hasClass('active')) return;

            $('body').addClass('is-navigating');
            $modelLinks.removeClass('is-loading');
            $link.addClass('is-loading');
        });
    } */

    /**
     * Al volver atrás el navegador restaura el DOM desde bfcache con las clases
     * puestas: sin esto la galería se queda atenuada para siempre.
     */
    /* window.addEventListener('pageshow', function () {
        $('body').removeClass('is-navigating');
        $('.models a[data-post-id]').removeClass('is-loading');
    }); */
    

    function loadModelFragments(postId, $container) {
        // 1. Si ya lo tenemos en cache JS local, renderizar al instante
        if (modelCache[postId]) {
            renderProductFragment(modelCache[postId], $container);
            return;
        }

        // 2. Feedback visual (Loader / Opacidad)
        $container.css('opacity', '0.55').addClass('is-loading');

        /* El fragmento tarda segundos en llegar, y mientras tanto la ficha que se ve ya no
           es la que se va a quedar: sin esto se puede anadir al carrito, abrir el menu o
           pedir otro modelo sobre contenido que esta a punto de desaparecer. La pagina deja
           de aceptar clics hasta que la peticion termina, salga bien o mal. */
        document.body.classList.add('is-navigating');

        $.ajax({
            url: window.translations.ajax_url,
            type: 'POST',
            data: {
                action: 'get_model_fragments',
                post_id: postId
            },
            success: function (response) {
                if (response.success && response.data) {
                    // Guardar en memoria cliente
                    modelCache[postId] = response.data;

                    renderProductFragment(response.data, $container);
                } else {
                    console.error('Error fragment:', response.data);
                    $container.css('opacity', '1').removeClass('is-loading');
                }
            },
            error: function (xhr, status, error) {
                console.error('AJAX Error:', error);
                $container.css('opacity', '1').removeClass('is-loading');
            },
            /* En complete y no en success: si la peticion falla o el fragmento viene vacio,
               la pagina tiene que volver a responder igualmente. */
            complete: function () {
                document.body.classList.remove('is-navigating');
            }
        });
    }

    function renderProductFragment(data, $container) {

        /* El fragmento trae el contenedor de la ficha entero, asi que se sustituye el elemento
           y no su contenido: metiendolo dentro quedaban dos .entry.product anidados y el mismo
           id de producto dos veces en la pagina. */
        const $ficha = $(data.html).filter('.product').first();

        if (!$ficha.length) {
            $container.css('opacity', '1').removeClass('is-loading');
            return;
        }

        $container.replaceWith($ficha);
        $ficha.css('opacity', '1').removeClass('is-loading');

        // Actualizar URL sin recargar la página (History API)
        if (data.url) {
            window.history.pushState({ postId: data.postId }, data.title, data.url);
            document.title = data.title;
        }

        // Re-inicializar el configurador con los nuevos datos del formulario
        if (typeof window.init_product_builder === 'function') {
            window.init_product_builder($ficha[0]);
        }

        // Re-inicializar iconos
        if (typeof lucide !== 'undefined') {
            lucide.createIcons();
        }

        // Re-inicializar Swiper usando la referencia global de window
        if (typeof window.init_sc_swipers === 'function') {
            window.init_sc_swipers($ficha[0]);
        }

        // Re-inicializar variaciones de WooCommerce si las hay
        let $form = $ficha.find('.variations_form');
        if ($form.length && typeof $.fn.wc_variation_form !== 'undefined') {
            $form.wc_variation_form();
        }

        // Re-inicializar galerías de producto si usas flexslider / photoSwipe nativo
        if (typeof $.fn.wc_product_gallery !== 'undefined') {
            $ficha.find('.woocommerce-product-gallery').each(function () {
                $(this).wc_product_gallery();
            });
        }

        // Trigger por si tienes otros scripts acoplados
        $(document.body).trigger('updated_wc_div');
    }

    // Listener del selector de modelo (radio / pill)
    $(document).on('click', '.models a[data-post-id]', function (e) {
        // Avoid link page load
        e.preventDefault();

        if ($(this).hasClass('active') || $(this).find('span').hasClass('active')) return;

        let postId = $(this).data('post-id');
        if (postId) {
            loadModelFragments(postId, $(".entry.product"));
        }
    });
});
